import { Row } from "react-bootstrap";
import { useIntl } from "react-intl";
import { AdminFillingGridsDashboard, NLGridDashboard } from "src/app/components";
import Pacman from "src/app/components/layout/Pacman";
import { useSiteAdminStats, useSiteManagerStats } from "src/app/hooks";

const SiteAdminStatsGridsContainer = () => {
    const { siteManagerStats: siteHasManagerNetlinkingStats, loading: loadingNetlinkingStats } =
        useSiteManagerStats("netlinking");

    const { siteAdminStats, loading: loadingFillingStats } = useSiteAdminStats("filling");

    const { formatMessage } = useIntl();
    return (
        <>
            <Row className="h-100 mt-15">
                <h2>{formatMessage({ id: "dashboard.order.netlinking.title" })}</h2>
                {loadingNetlinkingStats ? (
                    <div className="d-flex w-100 h-100 justify-content-center">
                        <Pacman />
                    </div>
                ) : (
                    <NLGridDashboard
                        siteHasManagerNetlinkingStats={siteHasManagerNetlinkingStats}
                    />
                )}
            </Row>

            <Row className="h-100 mt-15">
                <h2>{formatMessage({ id: "dashboard.order.fillingAI.title" })}</h2>
                {loadingFillingStats ? (
                    <div className="d-flex w-100 h-100 justify-content-center">
                        <Pacman />
                    </div>
                ) : (
                    <AdminFillingGridsDashboard siteHasManagerFillingStats={siteAdminStats} />
                )}
            </Row>
        </>
    );
};

export default SiteAdminStatsGridsContainer;
